import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";

const UrlField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
          pattern: {
            value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
            message: "Please enter a valid URL",
          },
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            type="url"
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            label={field.label}
            required={field.required}
          />
        )}
      />
    </Box>
  );
};

export default UrlField;
